export const LOGIN_PATH = "/login";

export function isLoginPath(pathname: string): boolean {
  return pathname === LOGIN_PATH;
}

/**
 * Reject open redirects: only same-app paths, never protocol-relative or login.
 */
export function safeReturnPath(from: string | null | undefined): string {
  if (!from || !from.startsWith("/") || from.startsWith("//")) {
    return "/";
  }
  const pathname = from.split("?")[0] ?? from;
  if (pathname === LOGIN_PATH) {
    return "/";
  }
  return from;
}

export function loginLocation(pathname: string, search = ""): string {
  if (isLoginPath(pathname)) {
    return LOGIN_PATH;
  }
  const from = `${pathname}${search}`;
  const params = new URLSearchParams();
  params.set("from", from);
  return `${LOGIN_PATH}?${params.toString()}`;
}

export function pathAfterLogin(search: string): string {
  const query = search.startsWith("?") ? search.slice(1) : search;
  return safeReturnPath(new URLSearchParams(query).get("from"));
}
